/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * jsonfix/app.js
 * this is code for the web frontend.
 */

var JSONFix = __webpack_require__(1);
var editorSource = void 0;
var editorResult = void 0;

window.onload = function () {
  editorSource = CodeMirror.fromTextArea(document.getElementById('source'), {
    lineNumbers: true,
    mode: 'application/json'
  });
  editorResult = CodeMirror.fromTextArea(document.getElementById('result'), {
    lineNumbers: true,
    mode: 'application/json'
  });
};

function update() {
  var jsonfix = new JSONFix(jsonlint);
  var fixed = jsonfix.process(editorSource.getDoc().getValue());

  if (fixed.isValid) {
    editorResult.getDoc().setValue(fixed.input);
    setResultMessage(fixed.message, 'pass');
  } else {
    if (fixed.wasFixed === true) {
      editorResult.getDoc().setValue(JSON.stringify(fixed.result, null, 2));
      setResultMessage(fixed.message, 'fixed');
    } else {
      editorResult.getDoc().setValue('');
      setResultMessage(fixed.message, 'fail');
    }
  }

  // document.getElementById('result-container').style.visibility = ''

  setResultData(fixed);
  setResultViz(fixed);
}

function setResultMessage(text, type) {
  var resultMessage = document.getElementById('result-message');
  resultMessage.innerHTML = text;
  resultMessage.className = type;
}

function setResultData(data) {
  console.log(data);
  var tmpData = {
    input: data.input,
    isValid: data.isValid,
    wasFixed: data.wasFixed,
    message: data.message,
    result: data.result,
    totalTries: data.totalTries,
    errorList: data.errorList
  };
  var resultData = document.getElementById('result-data');
  resultData.innerHTML = '<pre>' + JSON.stringify(tmpData, null, 2) + '</pre>';
}

function setResultViz(data) {
  var resultViz = document.getElementById('result-viz');
  var text = '';
  text += '<p>Total number of tries: ' + data.totalTries + '</p>';
  for (var i = 0; i < data.errorList.length; i++) {
    text += '<div>';
    text += '<p>';
    text += '<b>' + (i + 1) + '. Fix</b>';
    text += ' expecting: <code>' + data.errorList[i].expecting + '</code>';
    text += ' got: <code>' + data.errorList[i].got + '</code>';
    text += '</p>';
    text += '<pre>' + data.errorList[i].fix + '</pre>';
    text += '</div>';
  }
  resultViz.innerHTML = text;
}

window.jsonfix = {
  update: update
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JsonLintError = __webpack_require__(2);
var fix = __webpack_require__(3);

/**
 *
 */

var JSONFix = function () {
  /**
   * @param {Object} jsonlint - the jsonlint dependency
   */
  function JSONFix(jsonlint) {
    _classCallCheck(this, JSONFix);

    this.input = null; // store the input data as string
    this.isValid = null; // if input is valid, set to true
    this.wasFixed = null; // set to true if source was successful fixed
    this.message = null; // a message about the fix process
    this.result = null; // store the fixed json data here
    this.totalTries = 0; // count the number of "JSONFixer" calls
    this.errorList = []; // all found and fixed bugs will be reported here.
    this.jsonlint = jsonlint; // the jsonlint instance
    this.maximumTries = 100;
  }

  /**
   * functions
   * @param {String} src - json data
   * @return {String} fixed json data
   */


  _createClass(JSONFix, [{
    key: 'process',
    value: function process(src) {
      // set the input
      this.input = src;

      // reset some variables
      this.isValid = null;
      this.wasFixed = null;
      this.message = null;
      this.result = null;
      this.totalTries = 0;
      this.errorList = [];

      // first check if source is valid...
      try {
        var jsonParsed = JSON.parse(src);
        this.isValid = true;
        this.wasFixed = false;
        this.message = 'JSON is valid!';
        this.result = jsonParsed;
      } catch (e) {
        this.isValid = false;

        // check if source is empty
        if (src === '') {
          this.wasFixed = true;
          this.message = 'empty source detected...';
          this.result = {};
          this.totalTries = 1;
          // TODO: JSONFix.errorList.push({});
        } else {
          this.tryFix(this.normalize(src));
        }
      }

      // DEBUG(this.message);
      return this;
    }

    /**
     * optimize input source for bug detection
     *
     * @param {String} src - json data
     * @return {String} normalized json data
     */

  }, {
    key: 'normalize',
    value: function normalize(src) {
      var optimizedSrc1 = src.replace('{', '{\n');
      var optimizedSrc2 = optimizedSrc1.replace('}', '\n}');
      var optimizedSrc3 = optimizedSrc2.replace('",', '",\n');
      // TODO: remove whitespace
      // TODO: remove java style comments
      return optimizedSrc3;
    }

    /**
     * this function we call multiple times. (at the callbacks of the different fix functions)
     *
     * @param {String} src - json data
     * @return {this} this JSONFix instance
     */

  }, {
    key: 'tryFix',
    value: function tryFix(src) {
      this.totalTries++;

      // stop infinite loops after a maximum number of tries
      if (this.totalTries === this.maximumTries) {
        this.wasFixed = false;
        return this;
      }

      // console.log('JSONTryFix totalTries =', this.totalTries, 'source:', src);

      // try to lint the source. we use this to get the jsonlint error and detect the bug.
      try {
        var linted = this.jsonlint.parse(src);
        this.wasFixed = true;
        this.message = 'input was successfully fixed!';
        this.result = linted;
      } catch (e) {
        // save error to history
        var err = new JsonLintError().parse(e.message);
        this.errorList.push(err);

        // try to fix... check if fix method exists.
        switch (err.description) {
          case 'Parse error':
            err.message = null;
            err.fix = null;
            this.tryFixParseError(src, err);
            break;
          default:
            this.result = null;
            this.message = 'cannot fix the error type "' + err.description + '"... sorry';
            break;
        }
      }
    }

    /**
     * we only fix parse errors...
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     */

  }, {
    key: 'tryFixParseError',
    value: function tryFixParseError(input, err) {
      // check the error.got string and choose a fixer
      switch (err.got) {
        case 'EOF\'':
          {
            var fixedEOF = this.tryFixParseErrorEOF(input, err);
            this.tryFix(fixedEOF);
            break;
          }
        case 'undefined\'':
          {
            var tmp = this.tryFixParseErrorUndefined(input, err);
            this.tryFix(tmp);
            break;
          }
        case '}\'':
          {
            var _tmp = this.tryFixParseErrorCurlyBracket(input, err);
            this.tryFix(_tmp);
            break;
          }
        case ':\'':
          {
            var _tmp2 = this.tryFixParseErrorColon(input, err);
            this.tryFix(_tmp2);
            break;
          }
        case 'STRING\'':
          {
            // case "TRUE'":
            // case "FALSE'":
            var _tmp3 = this.tryFixParseErrorSTRING(input, err);
            this.tryFix(_tmp3);
            break;
          }
        case 'NUMBER\'':
          {
            var _tmp4 = this.tryFixParseErrorNUMBER(input, err);
            this.tryFix(_tmp4);
            break;
          }
        default:
          JSONFix.wasFixed = false;
          JSONFix.message = 'cannot fix got="' + err.got + '" ' + 'expecting="' + err.expecting + '"';
          throw new Error(JSONFix.message);
      }
    }

    /**
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     * @return {String} fixed json data
     */

  }, {
    key: 'tryFixParseErrorEOF',
    value: function tryFixParseErrorEOF(input, err) {
      // console.log('call tryFixParseErrorEOF')
      // console.log('input:', input)
      // console.log('err:', err)
      // console.log('cb:', cb);

      // check if last char is } or ]
      var lastChar = input[input.length - 1];
      // console.warn('last char', lastChar);
      if (lastChar !== '}' || lastChar !== ' ]') {
        // check if input is object or array...
        if (input[0] === '{') {
          // console.warn('input is object');
          input += '}';
          err.message = 'missing } at end of source';
          err.fix = input;
        }
        if (input[0] === '[') {
          // console.warn('input is array');
          input += ']';
          err.message = 'missing ] at end of source';
          err.fix = input;
        }
      }
      return input;
    }

    /**
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     * @return {String} fixed json data
     */

  }, {
    key: 'tryFixParseErrorUndefined',
    value: function tryFixParseErrorUndefined(input, err) {
      // console.log('call fixParseError_undefined');
      // console.log('input:', input)
      // console.log('err:', err)
      // console.log('cb:', cb);

      var inputLines = input.split('\n');
      // console.log('error at this line:', inputLines[err.line-1]);
      var tmp = inputLines[err.line - 1].split(',');
      // console.log(tmp);
      inputLines[err.line - 1] = tmp[0] + '",';

      var fixed = inputLines.join('\n');
      // console.log('fixed: "'+fixed+'"');

      // cb(fixed);
      return fixed;
    }

    /**
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     * @return {String} fixed json data
     */

  }, {
    key: 'tryFixParseErrorCurlyBracket',
    value: function tryFixParseErrorCurlyBracket(input, err) {
      // JSONFix.message = 'TODO: fix {';

      // if(err.expecting === "':'") {
      //   console.log('} & :');
      // } else if(err.expecting === "'STRING'") {
      //     console.log('} & STRING');
      // } else {
      //   fixParseError_CurlyBracket(input, err, cb);
      // };

      var inputLines = input.split('\n');
      // console.info('error at this line:', inputLines[err.line-1]);

      if (err.expecting === '\'STRING\'') {
        // console.log('too much "," ?');
        // check if comma is last char
        var totalchars = inputLines[err.line - 1].length;
        var lastChar = inputLines[err.line - 1][totalchars - 1];
        // console.log('totalchars:', totalchars);
        // console.log('lastChar:', lastChar);

        if (lastChar === ',') {
          // console.info('remove last char (,)');
          // fix it...
          inputLines[err.line - 1] = inputLines[err.line - 1].replace(',', '');
        }

        var fixed = inputLines.join('\n');
        err.fix = fixed;
        // console.log('fixed: "'+fixed+'"');

        // cb(fixed);
        return fixed;
      } else if (err.expecting === '\'EOF\', \'}\', \':\', \',\', \']\'') {
        return input;
      } else if (err.expecting === '\',\', \']\'') {
        inputLines[err.line - 1] += ']';
        return inputLines.join('\n');
      }
    }

    /**
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     * @return {String} fixed json data
     */

  }, {
    key: 'tryFixParseErrorColon',
    value: function tryFixParseErrorColon(input, err) {
      if (err.expecting === '\'EOF\', \'}\', \',\', \']\'') {
        var firstChar = input[0];
        var lastChar = input[input.length - 1];
        // console.log('firstChar', firstChar);
        // console.log('lastChar', lastChar);

        // check if { is missing...
        if (firstChar !== '{' && lastChar === '}') {
          err.message = 'missing { at the beginning of the json';
          var fixed = '{' + input;
          err.fix = fixed;
          return fixed;
        }

        // check if [ is missing...
        if (firstChar !== '[' && lastChar === ']') {
          err.message = 'missing [ at the beginning of the json';
          var fixed2 = '[' + input;
          err.fix = fixed2;
          return fixed2;
        }
      }

      if (err.expecting === '\'STRING\', \'NUMBER\', \'NULL\', \'TRUE\', \'FALSE\', \'{\', \'[\'') {
        // multiple colon
      }
    }

    /**
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     * @return {String} fixed json data
     */

  }, {
    key: 'tryFixParseErrorSTRING',
    value: function tryFixParseErrorSTRING(input, err) {
      var inputLines = input.split('\n');
      // console.log('inputLines:', inputLines);
      // console.log('buggyCode:', inputLines[err.line-1]);

      if (err.expecting === '\'EOF\', \'}\', \',\', \']\'') {
        err.message = 'missing comma';
        // console.log(err.messsage);
        var fixed = fix.missingComma(inputLines[err.line - 1]);
        err.fix = fixed;
        inputLines[err.line - 1] = fixed;
      } else if (err.expecting === '\'EOF\', \'}\', \':\', \',\', \']\'') {
        // is colon missing?
        if (inputLines[err.line - 1].indexOf(':') === -1) {
          // console.log('cannot find colon');

          err.message = 'missing colon';
          // console.log(err.message);
          var tmpFixed = fix.missingColon(inputLines[err.line - 1]);
          err.fix = tmpFixed;
          inputLines[err.line - 1] = tmpFixed;
        }

        // is comma missing?
        if (inputLines[err.line - 1].indexOf(',') === -1) {
          // console.log('cannot find ,');
          var fixed3 = fix.missingComma(inputLines[err.line - 1]);
          err.fix = fixed3;
          inputLines[err.line - 1] = fixed3;
        }
      } else {
        JSONFix.message = 'cannot fix this ugly bug... sorry!';
        JSONFix.wasFixed = false;
      }

      var fixedResult = inputLines.join('\n');
      // console.info('fixedResult: "'+fixedResult+'"');
      return fixedResult;
    }

    /**
     * @param {String} input - json data
     * @param {Object} err - jsonlint error
     */

  }, {
    key: 'tryFixParseErrorNUMBER',
    value: function tryFixParseErrorNUMBER(input, err) {
      // if (err.expecting === '\'EOF\', \'}\', \',\', \']\'') {
      //
      // }
    }
  }]);

  return JSONFix;
}();

if (true) {
  module.exports = JSONFix;
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * JsonLint error parser and data structure
 */

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JsonLintError = function () {
  /**
   * the error data structure we want to return.
   */
  function JsonLintError() {
    _classCallCheck(this, JsonLintError);

    this.description = '';
    this.line = '';
    this.code = '';
    this.expecting = '';
    this.got = '';
  }

  /**
   * parse a jsonlint message and return an error object with
   * description, line, code, expecting and got elements
   *
   * @param {String} msg - the output from jsonlint
   * @return {Object}
   */


  _createClass(JsonLintError, [{
    key: 'parse',
    value: function parse(msg) {
      var errorLines = msg.split('\n');
      this.description = errorLines[0].split(' on line ')[0];
      this.line = errorLines[0].split('on line ')[1].split(':')[0];
      this.code = errorLines[1];
      this.expecting = errorLines[3].split('Expecting ')[1].split(', got ')[0];
      this.got = errorLines[3].split(', got \'')[1];
      // console.log('------------------------');
      // console.log(this);
      // console.log('------------------------');
      return this;
    }
  }]);

  return JsonLintError;
}();

module.exports = JsonLintError;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * fix missing colon
 *
 * @param {Srtring} input - part of json data
 * @return {String} fixed json data
 */

exports.missingColon = function (input) {
  if (!input || input === '') {
    return '';
  } else {
    var tmp = input.split('"');
    var fixedLine = '';
    if (tmp.length === 3) {
      fixedLine = tmp[0] + '"' + tmp[1] + '":';
    } else if (tmp.length === 5) {
      fixedLine = tmp[0] + '"' + tmp[1] + '":' + tmp[2] + '"' + tmp[3] + '"' + tmp[4];
    } else {
      throw new Error('cannot set colon');
    }
    return fixedLine;
  }
};

/**
 * fix missing comma
 *
 * @param {Srtring} input - part of json data
 * @return {String} fixed json data
 */
exports.missingComma = function (input) {
  if (!input || input === '') {
    return '';
  } else {
    return input + ',';
  }
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.build.js